import { render, staticRenderFns } from "./QuesresultsPreview.vue?vue&type=template&id=6e8717f7&scoped=true&"
import script from "./QuesresultsPreview.vue?vue&type=script&lang=js&"
export * from "./QuesresultsPreview.vue?vue&type=script&lang=js&"
import style0 from "./QuesresultsPreview.vue?vue&type=style&index=0&id=6e8717f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8717f7",
  null
  
)

export default component.exports